/**
 * TradeStack - Main Layout Component
 */

import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useConfig } from '../context/ConfigContext';
import './Layout.css';

function Layout() {
  const { user, logout } = useAuth();
  const { platform } = useConfig();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/jobs', label: 'Jobs', icon: '🔨' },
    { path: '/customers', label: 'Customers', icon: '👥' },
    { path: '/estimates', label: 'Estimates', icon: '📝' },
    { path: '/invoices', label: 'Invoices', icon: '💰' },
    { path: '/expenses', label: 'Expenses', icon: '🧾' },
    { path: '/receipts', label: 'Receipts', icon: '📷' },
    { path: '/mileage', label: 'Mileage', icon: '🚗' },
    { path: '/reports', label: 'Reports', icon: '📈' },
  ];

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h1 className="sidebar-logo">{platform.name || 'TradeStack™'}</h1>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle sidebar"
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? 'active' : ''}`
              }
            >
              <span className="sidebar-icon">{item.icon}</span>
              {sidebarOpen && <span className="sidebar-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <NavLink to="/settings" className="sidebar-link">
            <span className="sidebar-icon">⚙️</span>
            {sidebarOpen && <span className="sidebar-label">Settings</span>}
          </NavLink>
        </div>
      </aside>

      {/* Main Content */}
      <div className="main-wrapper">
        {/* Top Header */}
        <header className="top-header">
          <div className="header-left">
            <button
              className="mobile-menu-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              ☰
            </button>
          </div>

          <div className="header-right">
            <div className="user-menu">
              <span className="user-name">
                {user?.firstName || user?.email}
              </span>
              <span className="user-tier badge badge-info">
                {user?.tier?.toUpperCase() || 'FREE'}
              </span>
              <button
                className="btn btn-secondary btn-sm"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
